import Image from "next/image";

interface UserInfoBoxProps {
  name: string;
  email: string;
  onConfirmDisable: () => void;
}

export default function UserInfoBox({ name, email, onConfirmDisable }: Readonly<UserInfoBoxProps>) {
  return (
    <div className="fixed bottom-2 flex justify-center w-full z-10">
      <div className="min-w-[42vw] w-auto h-[8vh] bg-black text-white text-sm rounded-md p-3 shadow-md flex justify-between items-center border rounded-x ">
        <p className="pr-10 pl-3">
          Visualizando como{" "}
          <b>
            {name} - {email}{" "}
          </b>
        </p>
        <button
          onClick={onConfirmDisable}
          className="bg-afya-red-100 text-white hover:bg-afya-red-200 py-2 px-3 h-[36px] text-sm rounded-md font-semibold flex justify-center items-center gap-2"
        >
          <Image src="/x-circle.svg" alt="x" width={16} height={16} /> Encerrar Visualização
        </button>
      </div>
    </div>
  );
}
